import MainAvatar from "./MainAvatar";

export default MainAvatar;
